
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VillageHouseDeclaration from "../pages/village-house-declaration/page";
import T1Technician from "../pages/t1-technician/page";
import T3Technician from "../pages/t3-technician/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/village-house-declaration",
    element: <VillageHouseDeclaration />,
  },
  {
    path: "/t1-technician",
    element: <T1Technician />,
  },
  {
    path: "/t3-technician",
    element: <T3Technician />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
